import {
    SET_AUTH_ERROR,
    CLEAR_AUTH_ERROR,
    UPDATE_SMART_LOADER
} from "./constants";

export const setAuthError = () => ({ type: SET_AUTH_ERROR });
export const clearAuthError = () => ({ type: CLEAR_AUTH_ERROR });

export const updateSmartLoader = (loader) => ({ type: UPDATE_SMART_LOADER, loader });
